/**
 * Email Service Integration
 * This service handles sending the growth strategy via email.
 * For production, connect this to a Supabase Edge Function + Resend.
 */
import { supabase } from '../supabase/supabase';

export const sendStrategyEmail = async (email, businessName, promptContent) => {
  try {
    // We call a Supabase Edge Function named 'send-strategy-email'
    // You will need to create this in your Supabase Dashboard
    const { data, error } = await supabase.functions.invoke('send-strategy-email', {
      body: { 
        to: email, 
        subject: `Growth Strategy: ${businessName}`,
        content: promptContent 
      },
    });

    if (error) throw error;
    return { success: true, data };
  } catch (err) {
    console.error("Email Service Error:", err);
    // Fallback: Open mailto link if function isn't deployed
    const mailtoUrl = `mailto:${email}?subject=Your Growth Strategy: ${businessName}&body=${encodeURIComponent(promptContent)}`;
    window.location.href = mailtoUrl;
    return { success: false, error: err.message, usedFallback: true };
  }
};